import React from 'react'
import style from './InteractOne.module.sass'
import Sketch from "react-p5"


class InteractOne extends React.Component {
    constructor(props) {
        super(props)
        this.sketchOne = React.createRef()
        this.state = {
            sketchOneWidth: 0,
            sketchOneHeight: 0,
        }
    }

    componentDidMount() {
        this.setState({ sketchOneWidth: this.sketchOne.current.offsetWidth })
        this.setState({ sketchOneHeight: this.sketchOne.current.offsetHeight })
    }


    render() {

        return (
            <>

                <div ref={this.sketchOne} className={`${style.sketchOneContainer} main`}>
                    <svg className={`${style.padOne} padOne`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.13 502.49">
                        <g id="Group_11" data-name="Group 11" transform="translate(-251.514 -379.484)">
                            <rect className="padOneColor" id="Rectangle_38" data-name="Rectangle 38" width="502.49" height="196.073" rx="98.037" transform="translate(297.613 881.975) rotate(-90)" />
                            <rect className="padOneColor" id="Rectangle_39" data-name="Rectangle 39" width="133.262" height="62.387" rx="31.193" transform="translate(251.514 700.858) rotate(-90)" />
                            <rect className="padOneColor" id="Rectangle_40" data-name="Rectangle 40" width="133.262" height="62.387" rx="31.193" transform="translate(479.257 702.028) rotate(-90)" />
                        </g>
                    </svg>
                    <div className={style.sketchOne}>
                        <SketchOne theme={this.props.theme} width={this.state.sketchOneWidth} height={this.state.sketchOneHeight}/>
                    </div>
                </div>

                <div className = {`${style.quoteContainer} main`}>
                    <div className = {`${style.quoteMain} quoteMain`}>"We can’t continue as a human race without periods - and <span>yet we still can’t acknowledge their existence."</span></div>
                    <div className = {`${style.quoteAuthor} quoteAuthor`}>- Emma Barnett</div>
                </div>


            </>

        )
    }

}


class SketchOne extends React.Component {
    r;
    g;
    b;
    d;
        
        render() {

        return (
            <>
                <div id={`sketchOne`}>
                    <Sketch
                        setup={
                            (p5, sketchOne) => {
                                p5.createCanvas(this.props.width*0.8, this.props.height*0.8).parent(sketchOne);
                                p5.noStroke();
                            }
                        }
                        draw={p5 => {
                            p5.clear();
                            this.r = p5.map(p5.mouseX, 0, p5.windowWidth, this.props.theme.r, this.props.theme.postR);
                            this.g = p5.map(p5.mouseX, 0, p5.windowWidth, this.props.theme.g, this.props.theme.postG);
                            this.b = p5.map(p5.mouseX, 0, p5.windowWidth, this.props.theme.b, this.props.theme.postB);

                            this.d = p5.map(p5.mouseX, 0, p5.width, p5.width*0.03, p5.width*0.12);
                            p5.fill(this.r, this.g, this.b);
                            p5.ellipse(p5.width / 2, p5.height / 2, this.d, this.d);
                        }}
                    />
                </div>

            </>
        )
    }
}



export default InteractOne